import React, { useMemo, useRef } from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import { AppBooter } from './AppBooter'
import { ThemeProvider, Global as EmotionGlobal, Theme } from '@emotion/react'
import { fusionScreenTheme } from '@fusion-advantage/formrender'
import { globalStyle, statusBarHeightPx } from './style'
import { createBrowserRouter, RouterProvider } from 'react-router'
// import RouteError from './stories/content/RouteError'
import AppRoot from './AppRoot'
import { PrintRoute, PrintRouteParams } from './PrintRoute'
import { PreviewRoute, PreviewRouteParams } from './PreviewRoute'
import { EncounterRoute, EncounterRouteParams } from './EncounterRoute'
import { ContentRouterElement } from './ContentRouterElement'
import { AppStore, createIsolatedAppStore } from './redux/appStore'
import { PrintSizeTest } from './PrintSizeTest'
import { restoreLoginReturnPath } from './lib/loginReturnPath'

// returning from a web SAML login lands on the root;
// put back the deep link the user started from before routing
restoreLoginReturnPath()

const router = createBrowserRouter([
	{
		path: '/',
		// TODO could potentially use this to catch and handle
		// any stray uncaught errors...
		// errorElement: <RouteError />,
		element: <AppBooter />,
		children: [
			{
				element: <AppRoot />,
				children: [
					{
						index: true,
						element: <ContentRouterElement />,
					},
					{
						// (temporary bearer token is provided by requesting service
						// in the URL itself)
						path: `print/:${PrintRouteParams.token}/encounter/:${PrintRouteParams.encounterGuid}/:${PrintRouteParams.pageIdx}?`,
						element: <PrintRoute />,
						children: [
							{
								index: true,
								element: <ContentRouterElement />,
							}
						],
					},
					{
						// auth is the normal web session cookie; if there is
						// none, the route shows the login screen and returns here
						path: `preview/branch/:${PreviewRouteParams.branchGuid}`,
						element: <PreviewRoute />,
						children: [
							{
								index: true,
								element: <ContentRouterElement />,
							}
						],
					},
					{
						// a real, editable encounter without going through the
						// dashboard; logs in first if needed, then returns here
						path: `encounter/:${EncounterRouteParams.encounterGuid}`,
						element: <EncounterRoute />,
						children: [
							{
								index: true,
								element: <ContentRouterElement />,
							}
						],
					},
					{
						path: `print-size-test`,
						element: <PrintSizeTest />
					},
				],
			},
		],
	},
])

const App = React.memo(props => {
	const appStore = useRef<AppStore>(createIsolatedAppStore())
	const theme = useMemo((): Theme => {
		return {
			...fusionScreenTheme,
			statusBarHeightPx: statusBarHeightPx(),
		}
	}, [])
	return (
		<ReduxProvider store={appStore.current}>
			<EmotionGlobal styles={globalStyle} />
			<ThemeProvider theme={theme}>
				<RouterProvider router={router} />
			</ThemeProvider>
		</ReduxProvider>
	)
})

export default App
